import React from "react";

import { faLink } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";

import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import useChangeTracking from "@mapmycustomers/shared/util/hook/useChangeTracking";

import { useConfigProvider } from "../../../ConfigProvider";
import ActionCallback from "../type/ActionCallback";

import LinkCreate from "./LinkCreate";
import ToggleButton from "./ToggleButton";

interface LinkInsertProps {
  onAction?: ActionCallback;
}

const LinkInsert = ({ onAction }: LinkInsertProps) => {
  const [linkInsertVisible, showLinkInsert, hideLinkInsert] = useBoolean();
  const configProvider = useConfigProvider();

  useChangeTracking(() => {
    if (linkInsertVisible) {
      onAction?.("Insert Link");
    }
  }, [linkInsertVisible, onAction]);

  return (
    <>
      <Tooltip title={configProvider.formatMessage("ui.emailBody.actions.insertLink")}>
        <ToggleButton onClick={showLinkInsert}>
          <FontAwesomeIcon icon={faLink} />
        </ToggleButton>
      </Tooltip>
      {linkInsertVisible && <LinkCreate onHide={hideLinkInsert} />}
    </>
  );
};

export default LinkInsert;
